import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import { PaymentCardsImages } from '../../images';

let BankDetails = ({ translate, currentLanguage, payment}) => {
  const paymentType = payment.cc_type ? payment.cc_type : ''
  let cardImage = "";
  if (paymentType.toUpperCase() === "ISRACARD"  || paymentType.toUpperCase() === "MASTERCARD"  ) {
    cardImage = PaymentCardsImages.mastercard
  } else if (paymentType.toUpperCase() === "VISA") {
    cardImage = PaymentCardsImages.visa
  } else if (paymentType.toUpperCase() === "AMEX") {
    cardImage = PaymentCardsImages.amex
  } else if (paymentType.toUpperCase() === "DINERS") {
    cardImage = PaymentCardsImages.diners
  } else {
    cardImage = PaymentCardsImages.placeholder
  }
  return (
    <div className="card card-section" id="payment">
      <div className="card-block">
        <div className="card-title">
          <h3>{translate("bank-details")}</h3>
        </div>
        <div className="form-line form-payment">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card">
                <div className="card-block">
                  <div className="row">
                    <div className="col text-md-right">
                      <div className="form-group form-group-payment-type">
                        <label style={{ peddinLeft: '50',justifyContent: 'center'}} ><img alt="cardImage" style={{height: '2em'}} src={cardImage} /></label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="form-group form-group-payment-number">
                        <label>{translate('number')}</label>
                        <div className="row">
                          <div className="col-3 pr-0">
                            <div className="form-control form-control-payment-number">XXXX</div>
                          </div>
                          <div className="col-3 pl-0">
                            <div className="form-control form-control-payment-number">XXXX</div>
                          </div>
                          <div className="col-3 pl-0">
                            <div className="form-control form-control-payment-number">XXXX</div>
                          </div>
                          <div className="col-3 px-0">
                            <div className="form-control form-control-payment-number">{payment.last_cc_numbers}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8">
                      <div className="form-group form-group-payment-name">
                        <label>{translate('card-holder')}</label>
                        <div className="form-control">{payment.cc_name}</div>
                      </div>
                    </div>
                    <div className="col-md-4 text-md-right">
                      <div className="form-group form-group-payment-expiration">
                        <label>{translate('expiration-date')}</label>
                        <div className="form-control">{`${payment.cc_expiration_month}/${payment.cc_expiration_year}`}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}
const viewMapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    payment: state.User.paymentMethod,
  }
}

const viewMapDispatchToProps = (dispatch) => {
  return {

  }
}

BankDetails = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(BankDetails);
export default BankDetails;



// WEBPACK FOOTER //
// ./src/components/InfoPerson/BankDetails.js